/**
 * Format date as DD/MM/YYYY
 * @param {string} iso - ISO date string
 * @returns {string} Formatted date string
 */
export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  } catch {
    return iso;
  }
}

/**
 * Format time as HH:MM AM/PM
 * @param {string} iso - ISO date string
 * @returns {string} Formatted time string
 */
export function formatTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12
    return `${hours}:${minutes} ${ampm}`;
  } catch {
    return iso;
  }
}

/**
 * Format date and time as DD/MM/YYYY, HH:MM AM/PM
 * @param {string} iso - ISO date string
 * @returns {string} Formatted datetime string
 */
export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return `${formatDate(iso)}, ${formatTime(iso)}`;
  } catch {
    return iso;
  }
}

export function daysUntil(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return Math.round((d - today) / (1000 * 60 * 60 * 24));
}
